import React, { useEffect, useState } from 'react'
import IconButton from '@mui/material/IconButton';
import CancelIcon from '@mui/icons-material/Cancel';
import { useFormik } from 'formik';
import MenuItem from '@mui/material/MenuItem';
import * as yup from 'yup';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

import { getCityList, getDealerCityList, getDealerEnquiries, getStateList } from '../../../networkCalls';
import { useStateValue, actionTypes } from '../../../store';
import { useNavigate } from 'react-router-dom';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const validationSchema = yup.object({
  dType: yup
    .string('Select Product')
    .notRequired(),
  zipcode: yup
    .string('Enter your Pincode ')
    .min(6, 'Min 6 Digit')
    .max(6, 'Max 6 Digit')
    .matches(/^[0-9]+$/, "Must be only digits")
    .required('Pincode is required'),
});

const catlistStatic = [
  {
    "id": 6,
    "name": "Generators",
  },
  {
    "id": 4,
    "name": "Water Pump",
  },
  {
    "id": 2,
    "name": "Tillers",
  },
  {
    "id": 3,
    "name": "Brush Cutters",
  },

  {
    "id": 5,
    "name": "Lawn Mower",
  },
  {
    "id": 7,
    "name": "General Purpose Engines",
  },
]
const stateList = [
  {
    value: 'ANDAMAN & NICOBAR',
    label: 'ANDAMAN & NICOBAR',
  },
  {
    value: 'ANDHRA PRADESH',
    label: 'ANDHRA PRADESH',
  },
  {
    value: 'ARUNACHAL PRADESH',
    label: 'ARUNACHAL PRADESH',
  },
  {
    value: 'ASSAM',
    label: 'ASSAM',
  },
  {
    value: 'BIHAR',
    label: 'BIHAR',
  },
  {
    value: 'CHANDIGARH',
    label: 'CHANDIGARH',
  },
  {
    value: 'DELHI',
    label: 'DELHI',
  },
  {
    value: 'GOA',
    label: 'GOA',
  },
  {
    value: 'GUJARAT',
    label: 'GUJARAT',
  },
  {
    value: 'HARYANA',
    label: 'HARYANA',
  },
  {
    value: 'HIMACHAL PRADESH',
    label: 'HIMACHAL PRADESH',
  },
  {
    value: 'J & K',
    label: 'J & K',
  },
  {
    value: 'JHARKHAND',
    label: 'JHARKHAND',
  },
  {
    value: 'KARNATAKA',
    label: 'KARNATAKA',
  },
  {
    value: 'KERALA',
    label: 'KERALA',
  },
  {
    value: 'LADAKH',
    label: 'LADAKH',
  },
  {
    value: 'MADHYA PRADESH',
    label: 'MADHYA PRADESH',
  },
  {
    value: 'MAHARASHTRA',
    label: 'MAHARASHTRA',
  },
  {
    value: 'MANIPUR',
    label: 'MANIPUR',
  },
  {
    value: 'MEGHALAYA',
    label: 'MEGHALAYA',
  },
  {
    value: 'MIZORAM',
    label: 'MIZORAM',
  },
  {
    value: 'NAGALAND',
    label: 'NAGALAND',
  },
  {
    value: 'ODISHA',
    label: 'ODISHA',
  },
  {
    value: 'PUDUCHERRY',
    label: 'PUDUCHERRY',
  },
  {
    value: 'PUNJAB',
    label: 'PUNJAB',
  },
  {
    value: 'RAJASTHAN',
    label: 'RAJASTHAN',
  },
  {
    value: 'TAMILNADU',
    label: 'TAMILNADU',
  },
  {
    value: 'TELANGANA',
    label: 'TELANGANA',
  },
  {
    value: 'TRIPURA',
    label: 'TRIPURA',
  },
  {
    value: 'UTTAR PRADESH',
    label: 'UTTAR PRADESH',
  },
  {
    value: 'UTTARAKHAND',
    label: 'UTTARAKHAND',
  },
  {
    value: 'WEST BENGAL',
    label: 'WEST BENGAL',
  },
];

const FindDealerCel = ({ catlist }) => {

  const navigate = useNavigate();
  // for result modal
  const [open, setOpen] = React.useState(false);
  const [{ token, huid }, dispatch] = useStateValue();

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [DealerDataList, setDealerDataList] = React.useState([]);

  const ChildModal = () => {
    return (
      <React.Fragment>
        <Modal
          //hideBackdrop
          open={open}
          //onClose={handleClose}
          aria-labelledby="title"
          aria-describedby="result-modal"
        >
          <Box sx={{ ...style, width: { xs: 320, sm: 800 }, }}>
            <IconButton
              onClick={handleClose}
              size="medium"
              edge="start"
              color="inherit"
              aria-label="open drawer"
              sx={{ float: 'right', position: 'absolute', right: '20px', top: '20px', zIndex: '3' }}
            >
              <CancelIcon />
            </IconButton>
            <div>
              <div className='row'>
                <div className='col-12 mb-3'>
                  <h4 className='d-inline-block m-0 fw-bold text-uppercase'>
                    <span className='txtred'>NEAREST</span> <span className='txtdgray'>DEALER</span>
                  </h4>
                </div>
              </div>
              <div className='row' style={{ maxHeight: '380px', overflow: 'auto' }}>
                {DealerDataList && DealerDataList?.length > 0 && DealerDataList?.map((data, key) => (
                  <div className='col-12 mb-1 f12' key={key} >
                    <h6 className='mb-0'>{data?.dealerName}</h6>
                    <div><span className='fw-bold'>Address : </span>{data?.dealerAddress1}, {data?.dealerCity}, {data?.dealerState}</div>
                    <div><span className='fw-bold'>Pin Code : </span>{data?.dealerPinCode}</div>
                    <div><span className='fw-bold'>Email : </span>{data?.dealerEmail}</div>
                    <hr />
                  </div>
                ))}
              </div>
            </div>
          </Box>
        </Modal>
      </React.Fragment>
    );
  }
  // end result modal


  const [openEnq, setopenEnq] = React.useState(false);
  const handleOpenEnq = () => setopenEnq(true);
  const handleCloseEnq = () => setopenEnq(false);


  const [state, setState] = useState('');
  const [cityList, setCityList] = React.useState([]);
  const pullCityList = (value) => {
    var data = new FormData();
    data.append('state', value);
    getDealerCityList(data).then((res) => {
      switch (res.data.status) {
        case 1:
          setCityList(res.data.dealerCityList);
          return true;
        case 0:
          break;
        default:
          return;
      }
    })
  }

  const [category, setCategory] = useState('');
  const pcatHandle = (e, value) => {
   
    //setCategory(value?.id)
    setCategory(value?.name)
  };

  const stateChange = (e, value) => {
    setState(value?.label)
    pullCityList(value?.label)
  };
  const [city, setCity] = useState('');
  const cityChange = (e, value) => {
    setCity(value?.label);
  };

  const formik = useFormik({
    initialValues: {
      dType: 'sales',
      //zipcode:'',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      var data = new FormData();
      data.append('category', category);
      // data.append('state', state);
      // data.append('city', city);
      data.append('saleService', values.dType);
      data.append('pincode', values.zipcode);
      // for (var pair of data.entries()) {
      //   console.log(pair[0] + ', ' + pair[1]);
      // }
      getDealerEnquiries(data).then((res) => {
        switch (res.data.status) {
          case 1:
            setDealerDataList(res.data?.dealerList);
            dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'success' });
            dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
            dispatch({ type: actionTypes.SET_MSGALERT, value: true });
            if (res.data?.dealerList?.length > 0) {
              setOpen(true);
            }
            return true;
          case 0:
            dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'error' });
            dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
            dispatch({ type: actionTypes.SET_MSGALERT, value: true });
            break;
          default:
            return;
        }
      })
    },
  });


  return (
    <>
      <div className='dealerbg'>
        <div className='p-3'>
          <div className='p-5 border'>
            <h4 className='d-block m-0 fw-bold text-uppercase mb-3'>
              <span className='txtred d-block mb-1'>FIND YOUR</span> <span className='text-white'>NEAREST DEALER</span>
            </h4>
            {/* <a href='/service-network' >CLICK HERE</a> */}
            <Button color="error" 
              onClick={()=>navigate(`/service-network`)}
              variant="contained" type="submit">
              CLICK HERE
            </Button>
          </div>
        </div>
      </div>
      <Modal
        open={openEnq}
        // onClose={handleCloseProfile}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...style, width: { xs: 340, sm: 760 }, }}>
          <IconButton
            onClick={handleCloseEnq}
            size="medium"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{ float: 'right', position: 'absolute', right: '20px', top: '20px', zIndex: '3' }}
          >
            <CancelIcon />
          </IconButton>
          <div>
            <div className='row'>
              <div className='col-12 mb-3'>
                <h4 className='d-inline-block m-0 fw-bold text-uppercase'>
                  <span className='txtred'>FIND YOUR</span> <span className='txtdgray'>NEAREST DEALER</span>
                </h4>
              </div>
            </div>
            <form onSubmit={formik.handleSubmit} autoComplete="off">
              <div className='row'>
                <div className='col-12 col-md-6'>
                  <Autocomplete
                    disablePortal
                    id="category"
                    className='mb-3'
                    name="category"
                    getOptionLabel={option => option.name}
                    options={catlistStatic}
                    // defaultValue={}
                    onChange={pcatHandle}
                    sx={{ width: '100%' }}
                    renderInput={(params) => <TextField
                      variant="standard" {...params}
                      required
                      label="Select Category" />}
                  />
                </div>
                <div className='col-12 col-md-6'>
                  <TextField
                    required
                    className='mb-4 w-100'
                    variant="standard"
                    id="zipcode"
                    name="zipcode"
                    inputProps={{
                      maxLength: 6
                    }}
                    label="Pincode"
                    type="text"
                    value={formik.values.zipcode}
                    onChange={formik.handleChange}
                    error={formik.touched.zipcode && Boolean(formik.errors.zipcode)}
                    helperText={formik.touched.zipcode && formik.errors.zipcode}
                  />
                </div>
                <div className='col-12 col-md-6'>
                  <FormControl>
                    <FormLabel id="label" className='f10'>Dealer Type</FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="dealer-type"
                      defaultValue="sales"
                      name="dType"
                      value={formik.values.dType}
                      onChange={formik.handleChange}
                    >
                      <FormControlLabel value="sales" control={<Radio />} label="Sales" />
                      <FormControlLabel value="service" control={<Radio />} label="Service" />
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>
              <Button color="error" variant="contained" className='w-100 mt-3' type="submit">
                View List
              </Button>
            </form>
          </div>
          <ChildModal />
        </Box>
      </Modal>
    </>
  )
}

export default React.memo(FindDealerCel)